  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import * as React from 'react';
import { DialogProvider, DialogSurfaceProvider } from '../../contexts';
import { DialogSurfaceMotion } from '../DialogSurfaceMotion';
/**
 * Render the final JSX of Dialog
 */ export const renderDialog_unstable = (state, contextValues)=>{
    const { content, open, trigger } = state;
    return /*#__PURE__*/ _jsx(DialogProvider, {
        value: contextValues.dialog,
        children: /*#__PURE__*/ _jsxs(DialogSurfaceProvider, {
            value: contextValues.dialogSurface,
            children: [
                trigger,
                content && /*#__PURE__*/ _jsx(DialogSurfaceMotion, {
                    appear: true,
                    visible: open,
                    unmountOnExit: true,
                    children: content
                })
            ]
        })
    });
};
